import { useRouteMatch } from "react-router";
export const useIsInTable = () => {
  return useRouteMatch({ path: "/area/:sectionId/:tableId" }) !== null;
};
